<!--
 * @Author: DYM
 * @Date: 2020-03-19 18:36:25
 * @LastEditors: DQL
 * @LastEditTime: 2022-01-28 15:43:58
 * @Description: 新增用户跳转的用户身份新增
 -->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="用户身份新增"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="118px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col c-form__part-title"
            :span="24"
          >
            用户基本信息
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="用户编码"
              prop="userCode"
            >
              <span
                class="c-form__read"
              >
                {{ initData.userVO.userCode }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="用户名称"
              prop="userName"
            >
              <span
                class="c-form__read"
              >
                {{ initData.userVO.userName }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="身份证件号码"
              prop="idNum"
            >
              <span
                class="c-form__read"
              >
                {{ initData.userVO.idNum }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="性别代码"
              prop="sex"
            >
              <span
                class="c-form__read"
              >
                {{ initData.userVO.sexName }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="联系电话"
              prop="tel"
            >
              <span
                class="c-form__read"
              >
                {{ initData.userVO.tel }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="邮箱"
              prop="email"
            >
              <span
                class="c-form__read"
              >
                {{ initData.userVO.email }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="入职时间"
              prop="joinTime"
            >
              <span
                class="c-form__read"
              >
                {{ initData.userVO.joinTime | date('yyyy-MM-dd') }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="离职时间"
              prop="leaveTime"
            >
              <span
                class="c-form__read"
              >
                {{ initData.userVO.leaveTime | date('yyyy-MM-dd') }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          />
          <el-col
            :span="24"
            class="c-form__col c-form__part-title"
          >
            用户登录账号信息
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="登录账号"
              prop="account"
            >
              <span
                class="c-form__read"
              >
                {{ initData.userAuthVO.account }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="有效期起"
              prop="effectStartDate"
            >
              <span
                class="c-form__read"
              >
                {{ initData.userAuthVO.effectStartDate | date('yyyy-MM-dd') }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="有效期止"
              prop="effectEndDate"
            >
              <span
                class="c-form__read"
              >
                {{ initData.userAuthVO.effectEndDate | date('yyyy-MM-dd') }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col c-form__part-title"
            :span="24"
          >
            新增身份信息
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="身份代码"
              prop="capacityCode"
            >
              <el-input
                v-model.trim="fd.capacityCode"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="身份名称"
              prop="capacityName"
            >
              <el-input
                v-model.trim="fd.capacityName"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="身份有效期起"
              prop="effectStartDate"
            >
              <el-date-picker
                v-model="fd.effectStartDate"
                type="date"
                placeholder="选择日期"
                value-format="timestamp"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="身份有效期止"
              prop="effectEndDate"
            >
              <el-date-picker
                v-model="fd.effectEndDate"
                type="date"
                placeholder="选择日期"
                value-format="timestamp"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="所属组织"
              prop="deptName"
            >
              {{ fd.deptName }}
            </el-form-item>
          </el-col>

          <el-col
            v-for="(attrCapacityItem, index) in attrCapacityList"
            :key="'attrCapacity'+ index"
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              :label="attrCapacityItem.attrName"
              :prop="'attrs.'+[attrCapacityItem.attrKey]"
            >
              <template v-if="attrCapacityItem.enums">
                <template v-if="enums[attrCapacityItem.enums] && Object.keys(enums[attrCapacityItem.enums]).length<=2">
                  <el-radio-group
                    v-model="fd.attrs[attrCapacityItem.attrKey]"
                    class="c-form__radio-group"
                  >
                    <el-radio
                      v-for="value in enums[attrCapacityItem.enums]"
                      :key="value.id"
                      :label="value.id"
                    >
                      {{ value.text }}
                    </el-radio>
                  </el-radio-group>
                </template>
                <template v-else>
                  <el-select
                    v-model="fd[attrCapacityItem.attrKey]"
                    class="c-form__select"
                    style="width: 100%;"
                    placeholder=""
                    clearable
                  >
                    <el-option
                      v-for="(value) in enums[attrCapacityItem.enums]"
                      :key="value.id"
                      :label="value.text"
                      :value="value.id"
                    />
                  </el-select>
                </template>
              </template>
              <template v-else-if="attrCapacityItem.attrType==='String'">
                <el-input
                  v-model.trim="fd[attrCapacityItem.attrKey]"
                  class="c-form__input"
                  placeholder=""
                />
              </template>
              <template v-else-if="attrCapacityItem.attrType==='Date'">
                <el-date-picker
                  v-model.trim="fd[attrCapacityItem.attrKey]"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { userService, capacityService, attrCapacity } from '../user.service';

export default {
  name: 'AddCapacityDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示
      loading: false, // 页面loading状态

      /* 表单初始化参数 Start */
      initData: {
        // 用户信息
        userVO: {
          email: null, // 邮箱
          idNum: null, // 身份证件号码
          joinTime: null, // 入职日期
          leaveTime: null, // 离职日期
          locked: 'N', // 是否锁定
          sex: null, // 性别
          sourceType: '0', // 数据来源
          tel: null, // 联系电话
          userName: null, // 用户名称
          userCode: null, // 用户编码
          valid: 'Y' // 有效标志
        },
        // 用户帐号信息
        userAuthVO: {
          account: null, // 帐号
          effectEndDate: null, // 有效期止
          effectStartDate: null, // 有效期起
          pwd: null // 密码
        },
        // 用户主身份信息 ,
        capacityVO: {
          capacityName: null, // 身份名称
          capacityCode: null, // 身份代码
          deptCode: null, // 身份所属组织/部门
          positionId: null, // 职位
          effectEndDate: null, // 身份有效期止
          effectStartDate: null, // 身份有效期起
          attrs: {} // 扩展字段
        }
      },
      /* 表单初始化参数 End */

      /* 表单参数 Start */
      fd: {
        capacityName: null, // 身份名称
        capacityCode: null, // 身份代码
        deptCode: null, // 部门代码
        effectEndDate: null, // 有效期止
        effectStartDate: null, // 有效期起
        userCode: null, // 用户代码
        valid: 'Y', // 有效标志
        deptName: null, // 所属组织
        attrs: {} // 扩展字段
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        capacityCode: [
          this.$validUtils.required('身份代码'),
          this.$HMValidator.maxLength('身份代码', 36)
        ],
        capacityName: [
          this.$validUtils.required('身份名称'),
          this.$HMValidator.maxLength('身份名称', 113)
        ],
        effectStartDate: [
          this.$validUtils.required('身份有效期起'),
          this.$HMValidator.startTime(this, 'fd', 'effectEndDate', ['身份有效期起', '身份有效期止'])
        ],
        effectEndDate: [
          this.$validUtils.required('身份有效期止'),
          this.$HMValidator.endTime(this, 'fd', 'effectStartDate', ['身份有效期起', '身份有效期止'])
        ]
      },
      /* 表单校验规则 End */

      /* 扩展字段 Start */
      attrCapacityList: [] // 身份
      /* 扩展字段 End */
    };
  },
  computed: {
    // 获取枚举
    enums () {
      const baseEnums = this.$HMStoreService.getEnums();
      const apiEnumsObj = this.$store.state.apiEnums;
      const apiKey = Object.keys(apiEnumsObj);
      let apiEnums = {};
      apiKey.forEach(_key => {
        apiEnums = Object.assign({}, apiEnums, apiEnumsObj[_key]);
      });
      return Object.assign({}, baseEnums, apiEnums);
    }
  },
  methods: {
    /**
     * @description: 页面初始化
     * @param {*}
     * @return {*}
     */
    init () {
      this.loading = true;
      userService.getUserInfo(this.fd.userCode)
        .then(rsp => {
          this.initData = Object.assign({}, this.initData, rsp.data);
          this.fd.capacityName = this.initData.userVO.userName;
          this.fd.effectStartDate = this.initData.userVO.joinTime;
          this.fd.effectEndDate = new Date('9999-12-31').getTime();
        })
        .catch(err => {
          console.error('初始化数据出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 获取扩展字段
     * @param {*}
     * @return {*}
     */
    getAttr () {
      // 获取身份扩展字段
      attrCapacity()
        .then(rsp => {
          this.attrCapacityList = rsp.data;
          rsp.data.map(attrUserItem => {
            this.attrSetToData(attrUserItem, this.fd.attrs, this.fdRules, 'attrs.' + attrUserItem.attrKey);
          });
        })
        .catch(err => {
          console.error('获取身份扩展字段出错！', err);
        });
    },
    /**
     * @description: 设置扩展字段到form表单数据、规则中
     * @param {Object} _attr 扩展字段
     * @param {Object} _formVo 表单数据对象
     * @param {Object} _formRules 校验规则对象
     * @param {String} _formRuleAttr 校验规则的属性
     * @return {*}
     */
    attrSetToData (_attr, _formVo, _formRules, _formRuleAttr) {
      this.$set(_formVo, _attr.attrKey, null);
      // 设置扩展字段校验规则
      this.$set(_formRules, _formRuleAttr, []);
      //  若扩展字段有必填标志，添加必填校验
      if (_attr.attrRequired === 'Y') {
        this.$set(_formRules, _formRuleAttr, [
          this.$validUtils.required(_attr.attrName)
        ]);
      }
      // 若扩展字段有自定义的校验规则，添加自定义的校验规则
      if (_attr.patterns) {
        const patterns = (_field, pattern) => {
          return {
            pattern: patterns,
            message: `【${_field}】校验不通过`,
            trigger: ['blur', 'change']
          };
        };
        // 向已有扩展字段校验规则数组末添加自定义校验规则
        this.$set(_formRules[_formRuleAttr], _formRules[_formRuleAttr].length,
          patterns(_attr.attrName, _attr.patterns));
      }
    },
    /**
     * @description: 新增保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      const _this = this;
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.loading = true;
          capacityService.save(_this.fd)
            .then(rsp => {
              _this.$alert('新增成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              _this.$emit('closeDialog', '');
              _this.$emit('callback');
            })
            .catch(err => {
              console.error('新增出错', err);
            })
            .finally(() => {
              _this.loading = false;
            });
        }
      });
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  mounted () {
    this.fd.userCode = this.dlParams.userCode;
    this.fd.deptCode = this.dlParams.deptCode;
    this.fd.deptName = this.dlParams.deptName;
    this.init();
    this.getAttr();
  }
};
</script>
